export default __webpack_public_path__ + "static/media/rmall-project-2.2051687d.jpg";